<template>
  <div
    class="chat-header flex flex-item-center"
    :class="applet && showType === 2 ? 'flex-end' : 'flex-between'"
    :style="{ background: themeColor }"
  >
    <div class="chat-header__title" v-if="showType === 2 && !applet">
      <template v-if="nav.type == 1">{{ `${nav.text}${config.pageTitle || ''}` }}</template>
      <template v-if="nav.type == 2">
        <el-image v-if="nav.logo && nav.logo != ''" class="chat-header__logo" :src="nav.logo" fit="contain" />
        {{ config.pageTitle || '' }}
      </template>
    </div>
    <div class="chat-header__title" v-if="showType === 1">{{ config?.nickname }}</div>

    <!-- 服务先知 -->
    <div v-if="showType === 2 && seerFlag" class="chat-header__tooltip">对方正在输入...</div>

    <div class="flex  flex-item-center">
      <span v-if="isShowComment" class="chat-header__btn" @click="commentOpen">
        <el-icon size="18"><Star /></el-icon>
        评价
      </span>
      <span v-if="isChangerService" class="chat-header__btn" @click="changeService">
        <img src="@/assets/images/service.png" alt="" />
        转人工
      </span>
      <span v-if="isChangeRobot" class="chat-header__btn" @click="changeRobot">
        <i class="iconfont icon-p058jiqiren" />
        转机器人
      </span>
      <span v-if="isShowClose" class="chat-header__btn" @click="closeSession">
        <img src="@/assets/images/close.png" alt="" />
        关闭会话
      </span>
    </div>
  </div>
</template>
<script setup>
import { Star } from '@element-plus/icons-vue'
import { styleType } from 'element-plus/es/components/table-v2/src/common'
import { defineProps, computed, defineEmits, ref, onMounted, onBeforeUnmount } from 'vue'
import { isWx, debounce, isMobile } from '@/utils/index'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  showType: { type: Number, default: 1 }, //接入机器人 1 接入客服员 2
  round: { type: Number }, //机器人消息回合
  robotEnable: { type: Boolean, default: true },
  closeSessionEnable: { type: Boolean, default: true },
  agentEnable: { type: Boolean, default: true },
  sessionStatus: { type: Number }, //会话状态
  seerFlag: { type: Boolean, default: false } //服务先知
})

// 是否显示评论
// const isShowComment = computed(() => {
//   if (props.styleConfig?.sessionComment && props.round > props.styleConfig.boutNum) return true
//   return false
// })


// 是否显示评论 升级版
const isShowComment = computed(() => {
  if (props.showType === 1 && props.styleConfig?.sessionComment && props.round > props.styleConfig.boutNum) return true
  if (props.showType === 2 && !mobiles.value) {
    let commentStyle = props.styleConfig?.commentStyle
    if (commentStyle && commentStyle.enabled === 1) {
      if (
        commentStyle.custSource.web === 1 &&
        ((commentStyle.roundLimit.enabled === 1 && props.round > parseInt(commentStyle.roundLimit.value)) ||
          commentStyle.roundLimit.enabled === 0)
      ) {
        return true
      }
    }
  }
  return false
})

// 是否显示转人工
const isChangerService = computed(() => {
  if (
    props.showType === 1 &&
    props.styleConfig.transferEntry &&
    props.styleConfig.transferEntryForm.showType === 1 &&
    props.agentEnable
  ) {
    return true
  }
  return false
})
// 是否显示转机器人
const isChangeRobot = computed(() => {
  if (props.showType === 2 && props.robotEnable) return true
  return false
})
// 是否显示关闭会话
const isShowClose = computed(() => {
  if (props.showType === 2 && props.closeSessionEnable && props.sessionStatus === 2 && !mobiles.value) return true
  return false
})
const applet = ref(false)
isWx().then((type) => {
  if (type !== 'no-wx') {
    applet.value = true
  }
})
const emit = defineEmits(['comment', 'switch', 'switchRobot', 'quit'])
const config = computed(() => {
  let style = props.styleConfig.styleConfig || {}
  if (Object.keys(style).length > 0) {
    return style
  } else {
    return {
      themeColor: '#3571F0',
      pageTitle: '',
      navigatorContent: { text: '', type: 1 },
      transferEntryForm: {},
      nickname: ''
    }
  }
})
const nav = computed(() => {
  let defaultNav = { text: '', logo: '', type: 1 }
  if (config.value && config.value.navigatorContent) {
    return config.value.navigatorContent
  }
  return defaultNav
})
const themeColor = computed(() => {
  // return props.showType === 1 ? '#3571F0' : config.value.themeColor
  return config.value.themeColor || '#3571F0' 
})
// 评论
const commentOpen = () => {
  emit('comment')
}
// 转人工
const changeService = debounce(() => {
  emit('switch', { type: 0 })
})
// 转机器人
const changeRobot = () => {
  emit('switchRobot')
}
// 关闭会话
const closeSession = () => {
  emit('quit')
}
// 是否是h5
const mobiles = ref(false)
const handleResize = () => {
  mobiles.value = isMobile()
}
onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})
defineExpose({
  open
})
</script>
<style scoped lang="less">
.chat-header {
  background: #3571f0;
  height: 44px;
  color: rgba(255, 255, 255, 1);
  padding: 0 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  &__tooltip {
    font-size: 12px;
  }
  &__title {
    display: flex;
    align-items: center;
  }
  &__logo {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 50%;
  }
  &__btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 3px 10px;
    border-radius: 4px;
    & + & {
      margin-left: 12px;
    }
    > i {
      font-size: 18px;
      margin-right: 4px;
      color: #ffffff;
    }
    img {
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
  }
}
</style>
